import { bl_fi_budget_category_grp_RowClass } from '../../../dbschema/bl_fi_budget_category_grp.model';
import { BaseContainerModel } from '../../base-container.model';


export class BudgetCategoryGroupContainerModel extends BaseContainerModel {
    bl_fi_budget_category_grp: bl_fi_budget_category_grp_RowClass = new bl_fi_budget_category_grp_RowClass();
}
